module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="salesforce-commerce-item-preview">\n    <div class="container">\n        ';
 if (status) { ;
__p += '\n            <div class="picture">\n                <div class="icon-info"></div>\n            </div>\n            <div class="details">\n                <div>\n                    <div class="overflow">Id: ' +
__e( productID ) +
'</div>\n                </div>\n                <div>\n                    <span class="wrap">No connection! Verify that your\n                        <a href="#integrations-salesforce-commerce">DW Settings</a> are OK and that the\n                        product is still available.</span>\n                </div>\n            </div>\n        ';
 } else { ;
__p += '\n            <div class="picture">\n                ';
 if (image) { ;
__p += '\n                    <img src="' +
__e( image ) +
'" />\n                    <div class="no-image hide"\n                        title="Product image failed to load: \'' +
__e( image ) +
'\'">Failed to load</div>\n                ';
 } else { ;
__p += '\n                    <div class="no-image">No Image</div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="details">\n                <div>\n                    <div class="overflow">' +
__e( name ) +
'</div>\n                </div>\n                <div>\n                    <span class="overflow">Id: ' +
__e( productID ) +
'</span>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceWidgetPreview.tpl
// module id = 3006
// module chunks = 0